import { StorageSerializers, useSessionStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { computed } from 'vue';

export type CreateHrAnagraphicData = {
  firstName: string;
  lastName: string;
  birthdate: string;
  email: string;
  phoneNumber: string;
};

const isValidAnagraphicData = (
  data: CreateHrAnagraphicData | null,
): data is CreateHrAnagraphicData =>
  !!data &&
  [
    data.firstName,
    data.lastName,
    data.birthdate,
    data.email,
    data.phoneNumber,
  ].every((field) => typeof field === 'string' && field.length > 0);

export const useCreateHrStore = defineStore('createHr', () => {
  const anagraphicData = useSessionStorage<CreateHrAnagraphicData | null>(
    'createHr.anagraphicData',
    null,
    { serializer: StorageSerializers.object },
  );

  const hasAnagraphicData = computed(() =>
    isValidAnagraphicData(anagraphicData.value),
  );

  const setAnagraphicData = (data: CreateHrAnagraphicData) => {
    anagraphicData.value = data;
  };

  const reset = () => {
    anagraphicData.value = null;
  };

  return { anagraphicData, hasAnagraphicData, setAnagraphicData, reset };
});
